import {
    errorAction,
    loadingAction,
    successSideEffectState,
    SideEffectSchema,
} from ".";

export const Actions = {
    //Disabled Modules
    GET_DISABLED_MODULES: "GET_DISABLED_MODULES",
    GET_DISABLED_MODULES_LOADING: "GET_DISABLED_MODULES_LOADING",
    GET_DISABLED_MODULES_ERROR: "GET_DISABLED_MODULES_ERROR",
    GET_DISABLED_MODULES_SUCCESS: "GET_VALID_USER_TOKEN_SUCCESS",

};

export interface IGetDisabledModules extends SideEffectSchema {
    data: Array<string>;
}


export const getDisabledModulesAction = (empId: any) => {
    return {
        type: Actions.GET_DISABLED_MODULES,
        payload: { empId },
    };
};

export const getDisabledModulesLoadingAction = () =>
    loadingAction(Actions.GET_DISABLED_MODULES_LOADING);

export const getDisabledModulesErrorAction = (error: string) =>
    errorAction(Actions.GET_DISABLED_MODULES_ERROR, error);

export const getDisabledModulesSuccessAction = (data: any) => {
    const payload: IGetDisabledModules = {
        data,
        // ...successSideEffectState,
    };
    return {
        type: Actions.GET_DISABLED_MODULES_SUCCESS,
        payload: payload,
    };
};
